module.exports = __webpack_public_path__ + "static/fonts/BMJUA.3cefbc6.woff";